module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.hidden) ? _c(_vm.linkTag, _vm._b({
    tag: "component",
    class: [
      'btn',
      _vm.icon ? ("btn--" + (_vm.negative ? 'negative' : 'positive')) : '',
      ("btn--" + (_vm.button || 'secondary')),
      ("btn--" + (_vm.size || 'm')),
      {
        'btn--icon': _vm.icon,
        'btn--idle': (!_vm.hover && !_vm.isHover && !_vm.active && !_vm.isActive) || (_vm.loadingSet),
        'btn--hover': (_vm.hover || _vm.isHover || _vm.active || _vm.isActive) && !_vm.disabledSet && !_vm.loadingSet,
        'btn--active': (_vm.active || _vm.isActive) && !_vm.disabledSet && !_vm.hover && !_vm.loadingSet,
        'btn--disabled': !_vm.success && !_vm.loadingSet && _vm.disabledSet,
        'btn--loading': _vm.loadingSet,
        'btn--success': _vm.successSet,
      }
    ],
    attrs: {
      "disabled": _vm.disabledSet || _vm.loadingSet || _vm.successSet
    },
    on: {
      "mouseover": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.onMouseDown.apply(null, arguments)
      },
      "click": _vm.onClick
    }
  }, 'component', _vm.linkProps, false), [_c('b', {
    staticClass: "btn__bg",
    style: ({
      'background-color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('module-dots', {
    class: "btn__dots",
    attrs: {
      "active": _vm.loadingSet
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn__inner"
  }, [_c('span', {
    staticClass: "btn__content"
  }, [_c('span', {
    staticClass: "btn__label"
  }, [_vm._v("\n        " + _vm._s(_vm.label || "")), (!_vm.label) ? _vm._t("default") : _vm._e()], 2), (_vm.icon) ? _c('module-icon', {
    class: "btn__icon",
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e()], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48f11949"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Button.vue
// module id = 243
// module chunks = 2